export { default } from './bitrix-inst';
